var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headline text-center"},[_vm._v(" Olá "),_c('b',[_vm._v(_vm._s(_vm.user_name))]),_vm._v(", boas-vindas ao sistema de cadastros e financeiro! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }